import { useGlobals } from "@/components/providers/globals-provider.tsx";
import getShortCode from "@/features/sub-families/queries/get-short-code.ts";
import useQueryApiClient from "@/hooks/use-query-api-client.ts";
import type { Nullable } from "@/types";

export default function useShortCode(smartNumber: Nullable<string>) {
    const { site, locale } = useGlobals();

    const hasSmartNumber = !!smartNumber;

    const { data, isLoading } = useQueryApiClient({
        queryKey: ["short-code", site, locale, smartNumber],
        queryFn: () => getShortCode(smartNumber, site, locale),
        enabled: hasSmartNumber,
    });

    return { shortCode: data?.shortcode ?? null, isLoading };
}
